import { Component } from '@angular/core';
import { JSONHash, RegistrationStep } from 'angular-lib';

@Component({
    selector: 'ez-gender',
    template: require('./gender.component.html'),
    styles: [require('./gender.component.less')]
})
export class GenderComponent extends RegistrationStep {

    public valid(obj: JSONHash) {
        this.registrationModel.genderId = obj.id;
        this.submit();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/gender/gender.component.ts